export default __webpack_public_path__ + "static/media/weightmachine.a567223c.png";